// extracted by mini-css-extract-plugin
export default {"loader_container":"style_loader_container__IIIYA","loader":"style_loader__TrRP4"};